import styled from 'styled-components';

export const ModelYearListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: Audi Type;
`;
